//@vendor
const Immutable = require('immutable');
//@actions
const actionTypes = require('../../loansConstants/actionTypes');
//@helper
const get = require('lodash/object/get');

const initialState = Immutable.fromJS({
    success: false,
    isFetching: true,
    error: false,
    interveners: []
});

function prepareInterveners(state, paramInterveners, nextPageLink) {
    const intervenersList = paramInterveners.map( intervener => ({
        personIdentifier: {
            personType: get(intervener, 'identificadorPersona.tipodepersona'),
            personCode: get(intervener, 'identificadorPersona.codigodepersona')
        },
        documentIdentifier: {
            documentTypeOfic: get(intervener, 'identificadorPersona.tipodocumentoofic'),
            documentCode: get(intervener, 'identificadorPersona.codigodedocumento')
        },
        intervenerName: get(intervener, 'nombreInterviniente'),
        intervenerType: get(intervener, 'tipoIntervencion'),
        intervenerOrder: get(intervener, 'ordenIntervencion'),
        responsabilityPercentaje: get(intervener, 'porcentajeResponsabilidad')
    }));

    const interveners =  Immutable.fromJS({
        isFetching: false,
        success: true,
        error: false,
        interveners: intervenersList,
        nextPage: nextPageLink
    });

    return state.mergeDeep(interveners);
}

//This is a subreducer
function loanIntervenersReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FETCH_LOAN_INTERVENERS:
            return state.set('isFetching', true);
        case actionTypes.FETCH_LOAN_INTERVENERS_SUCCESS:
            return prepareInterveners(state, action.payload.interveners, action.payload.nextPage);
        case actionTypes.FETCH_LOAN_INTERVENERS_FAILURE:
            return state.set('error', action.payload.error);
        default:
            return state;
    }
}

module.exports = loanIntervenersReducer;
